export default "__VITE_PUBLIC_ASSET__c7991a57__"